import { render, staticRenderFns } from "./PageEditProject.vue?vue&type=template&id=f10399ac"
import script from "./PageEditProject.vue?vue&type=script&lang=js"
export * from "./PageEditProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports